export default "__VITE_ASSET__BVD$R$cW__"